const initTableOfVariants = () => {
    const tableOfVariantsWidgetList = document.querySelectorAll("[data-table-of-variants-widget]");
    if (tableOfVariantsWidgetList && tableOfVariantsWidgetList.length > 0) {
        tableOfVariantsWidgetList.forEach((tableOfVariantsWidget) => {
            const indexList = tableOfVariantsWidget.querySelectorAll("[data-index]");
            const tableContainer = tableOfVariantsWidget.querySelector("[data-table-container]");
            if (indexList) {
                indexList.forEach((index) => {
                    index.addEventListener("click", () => {
                        const tableList = tableOfVariantsWidget.querySelectorAll("[data-table]");
                        if (!index.classList.contains("active")) {
                            for (let i = 0; i < indexList.length; i++) {
                                indexList[i].classList.remove("active");
                            }
                            index.classList.toggle("active");
                            const indexId = index.getAttribute("data-index");
                            const tableActive = tableOfVariantsWidget.querySelector(`[data-table='${indexId}'`);
                            tableList.forEach(table => table.classList.remove("active"));
                            if (!tableActive) {
                                const culture = document.querySelector("[data-language]").getAttribute("data-language").toString();
                                fetchTable(indexId, culture).then((response => {
                                    response.text().then(result => {
                                        if (result != null && result.trim() != "") {
                                            // Initialize the DOM parser
                                            const parser = new DOMParser();
                                            // Parse the text and convert it into HTML
                                            const parsedHTML = parser.parseFromString(result, "text/html");
                                            const parsedDistributosrCardsBox = parsedHTML.querySelector("[data-table]");
                                            tableContainer.append(parsedDistributosrCardsBox);
                                        }
                                    });
                                }));
                            }
                            else {
                                tableActive.classList.add("active");
                            }
                        }
                    });
                });
            }
        });
    }
};
const fetchTable = (indexId, culture) => {
    console.log("fetch");
    const fetchUrl = `/` + culture + `/product/GetVariantCharateristics`;
    return fetch(fetchUrl, {
        method: "post",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        //make sure to serialize your JSON body
        body: JSON.stringify({
            variantId: indexId,
            culture: culture
        })
    });
};
